module.exports = __webpack_public_path__ + "img/header.20209d7a.jpg";